<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="800">
    <v-card v-if="row != null">
      <ODialogBar title="Perfil" :subtitle="subtitle" @close="dismiss" />
      <v-card-text class="d-flex w-full h-500 pa-0">
        <div class="w-200 grow-0 shrink-0 sidebar-border sidebar-bg">
          <DesktopSideBar :tabItems="tabItems" :currentTab.sync="currentTab" />
        </div>
        <div class="grow-1 w-0">
          <TabContainer
            @reload="reload"
            :tabItems="tabItems"
            :currentTab="currentTab"
            :value="row"
          />
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { OrgApi } from '@/models/index.js'
import ProfileDetailsTab from './ProfileDetailsTab.vue'
import ProfilePermissionsTab from './ProfilePermissionsTab.vue'
import ProfileVehiclesTab from './ProfileVehiclesTab.vue'
import ProfileDriversTab from './ProfileDriversTab.vue'
import ProfilePortletsTab from './ProfilePortletsTab.vue'
import ProfileUsersTab from './ProfileUsersTab.vue'
import DesktopSideBar from 'oderon-vue/cpts/tabbed-interface/DesktopSideBar.vue'
import TabContainer from 'oderon-vue/cpts/tabbed-interface/TabContainer.vue'

export default {
  components: { DesktopSideBar, TabContainer },
  data() {
    return {
      orgId: null,
      id: null,
      row: null,
      currentTab: 'Geral',
      tabItems: [
        { value: 'Geral', component: ProfileDetailsTab },
        { value: 'Permissões', component: ProfilePermissionsTab },
        { value: 'Veículos', component: ProfileVehiclesTab },
        { value: 'Motoristas', component: ProfileDriversTab },
        { value: 'Painéis', component: ProfilePortletsTab },
        { value: 'Usuários', component: ProfileUsersTab }
      ]
    }
  },
  computed: {
    subtitle() {
      if (this.row == null || this.row.id == null) return ''
      return '#' + this.row.id
    }
  },
  methods: {
    open(orgId, id) {
      this.orgId = orgId
      this.id = id
      this.reload()
      return this.$refs.dialog.$open()
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    reload() {
      this.$refs.dialog.$loading(async () => {
        this.row = await this.fetchData()
      })
    },

    async fetchData() {
      let fetcher = new OrgApi(this.orgId)
      let row = await fetcher.get(`profiles/${this.id}`, {
        includeAssocs: true
      })
      row.orgId = this.orgId
      return row
    }
  }
}
</script>

<style lang="sass"></style>
